module.exports = __webpack_public_path__ + "static/img/classroom.973d285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/classroom.png
// module id = JycL
// module chunks = 0